export interface ConsultantListItem {
  id: number;
  first_name: string;
}

/**
 * Combina consultores e corretores parceiros numa única lista por id
 * (parceiros passam a usar o mesmo consultant_id no backend).
 */
export function mergeConsultantLists(
  consultants: ConsultantListItem[] | undefined,
  partnerBrokers: ConsultantListItem[] | undefined
): ConsultantListItem[] {
  const byId = new Map<number, ConsultantListItem>();
  for (const c of consultants ?? []) {
    byId.set(c.id, c);
  }
  for (const b of partnerBrokers ?? []) {
    if (!byId.has(b.id)) {
      byId.set(b.id, b);
    }
  }
  return Array.from(byId.values());
}
